import styled from "styled-components";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    margin-top: 75px;
    padding: 0 10px;
    width: 100%;
    @media (min-width: 720px) {
        margin: 40px 0 0 200px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        margin-left: 25px;
    }
`;

export const PageTitle = styled.h1`
    color: #006560;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    @media (min-width: 720px) {
        text-align: start;
    }
`;

export const CountContainer = styled.span`
    color: #9BA8C3;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 160%;
`;

export const HeaderContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 25px;
    justify-content: flex-start;
    margin-block: 25px;
    @media (min-width: 720px) {
        align-items: center;
        flex-direction: row;
        justify-content: flex-start;
    }
`;

export const ContainerList = styled.div`
    align-items: center;
    background: #F2F2F2;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    justify-content: center;
    padding: 10px;
    width: 100%;
    @media (min-width: 720px) {
        width: 95%;
    }
`;

export const LineTitle = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px;
    width: 98%;
`;

export const TitleText = styled.h1`
    color: #333;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: ${props => props.$align ? props.$align : 'start'};
    max-width: 20%;
    overflow: auto;
    white-space: nowrap;
    width: ${props => props.width ? props.width : '20%'};
    &::-webkit-scrollbar {
        height : 3px;
    }
    &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa;
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
`;

export const LineList = styled.a`
    align-items: center;
    background: #FFF;
    border-radius: 10px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px;
    text-decoration: none;
    width: 98%;
`;

export const ListText = styled.h1`
    color: #333;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    max-width: 20%;
    overflow: hidden;
    text-align: ${props => props.$align ? props.$align : 'start'};
    text-overflow: ellipsis;
    white-space: nowrap;
    width: ${props => props.width ? props.width : '20%'};
`;

export const ListButton = styled.button`
    background: none;
    border: none;
    border-radius: 5px;
    color: #33CC99;
    cursor: pointer;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    outline: none;
    padding-inline: 5px;
    white-space: nowrap;
    &:disabled{
        background: #A3A3A3;
        color: #fff;
        cursor: auto;
    }
`;

export const FilterInput = styled.input`
    border: none;
    color: #333;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 20px */
    outline: none;
`;

export const InputContainer = styled.div`
    align-items: center;
    border: 1px solid #3C9;
    border-radius: 10px;
    display: flex;
    gap: 15px;
    justify-content: center;
    padding: 12px 22px 12px 20px;
`;

export const ContainerHead = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 15px;
    width: 100%;
    @media (min-width: 720px) {
        flex-direction: row;
        width: 95%;
    }

    .admin-buttons {
        align-items: flex-end;
        display: flex;
        flex-direction: row;
        gap: 12px;
    }
`;

export const ContainerRow = styled.form`
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 90%;
    justify-content: flex-start;
    overflow: auto;
    width: 100%;
    @media (min-width: 1320px) {
        align-items: flex-start;
        flex-direction: row;
        justify-content: center;
    }
`;

export const ImageIcon = styled.img`
    height: 24px;
    width: 24px;
`;

export const ButtonsContainer = styled.div`
    align-items: center;
    display: flex;
    // flex-direction: column;
    gap: 25px;
    justify-content: center;
    padding-bottom: 20px;
    justify-self: flex-end;
    width: 100%;
    @media (min-width: 1320px) {
        flex-direction: row;
        justify-content: flex-end;
        width: 90%;
    }
`;

export const ContainerColumn = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 15px;
    justify-content: flex-start;
    padding: 20px;
    width: 80%;
    @media (min-width: 1320px) {
        width: 30%;
    }
`;

export const RowContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 18px;
    justify-content: center;
`;
